// Central brand + content configuration for CannaCheap DC.
// Edit this file to update contact info, service areas, FAQs and legal content.

export const SITE = {
  name: "CannaCheap DC",
  tagline: "Quality You Can Afford",
  url: process.env.REACT_APP_SITE_URL || "https://www.cannacheapdc.com",
  phone: "(202) 422-9366",
  phoneHref: "tel:+12024229366",
  email: "info@cannacheap.store",
  hours: "Open daily · 10 AM – 10 PM",
  instagram: "http://instagram.com/",
  facebook: "https://facebook.com/",
  logo: "/assets/logo.webp",
  description:
    "Premium, lab-tested cannabis at honest prices. Fast pickup & delivery across Washington DC, Maryland and Northern Virginia.",
  payments: ["Cash", "Cash App", "Zelle", "Apple Pay"],
  freeDeliveryMinimum: 80,
  orderMinimum: 60,
  ageLine: "21+ ONLY · VALID GOVERNMENT ID REQUIRED",
};

export const ANNOUNCEMENTS = [
  "21+ ONLY — VALID ID REQUIRED AT DELIVERY",
  "FREE DC DELIVERY ON ORDERS $80+ — USE CODE DC80",
  "PRICE MATCH PROMISE — FIND IT CHEAPER LOCALLY, WE MATCH IT",
  "NEW DAILY DEALS EVERY MORNING",
  "OPEN DAILY 10 AM – 10 PM",
];

export const TRUST_POINTS = [
  {
    icon: "MapPin",
    title: "Local DC Business",
    text: "Born and based in Washington DC. We know the city because we are the city.",
  },
  {
    icon: "BadgeCheck",
    title: "Quality, Verified",
    text: "Every product on the menu is carefully sourced and inspected for consistency and safety.",
  },
  {
    icon: "Tag",
    title: "Honest Pricing",
    text: "Premium products without the premium markup — plus a local price match promise.",
  },
  {
    icon: "Truck",
    title: "Fast & Discreet",
    text: "Most deliveries arrive in 30–90 minutes. Free delivery on orders $50+.",
  },
];

export const ORDER_STEPS = [
  {
    n: "01",
    title: "Browse the menu",
    text: "Explore flower, concentrates, edibles, pre-rolls and more — all priced honestly, all in one place.",
  },
  {
    n: "02",
    title: "Build your order",
    text: "Add your favorites to the cart and check out securely online in under two minutes.",
  },
  {
    n: "03",
    title: "Pickup or delivery",
    text: "Choose express pickup or same-day delivery anywhere in DC and select MD/VA neighborhoods.",
  },
  {
    n: "04",
    title: "Confirm & enjoy",
    text: "A team member confirms your order. Have your 21+ ID ready — that's it.",
  },
];

export const FAQS = [
  {
    q: "Do you offer delivery?",
    a: "Yes — fast, on-demand delivery throughout Washington DC, plus select Maryland and Northern Virginia neighborhoods. Most orders arrive within 30–90 minutes depending on location and order volume.",
  },
  {
    q: "Do you offer pickup?",
    a: "Yes. Place your order online and choose express pickup at checkout. Your order is prepared and ready when you arrive.",
  },
  {
    q: "What areas do you deliver to?",
    a: "All of Washington DC — The Wharf, Navy Yard, Georgetown, Capitol Hill, Adams Morgan, Shaw, Dupont Circle and every quadrant — plus Bethesda, Silver Spring, Takoma Park, Hyattsville and College Park in Maryland, and Arlington and Alexandria in Virginia.",
  },
  {
    q: "What payment methods do you accept?",
    a: "We accept Cash, Cash App, Zelle and Apple Pay.",
  },
  {
    q: "How do I place an order?",
    a: "Browse the menu, add products to your cart, and choose delivery or pickup at checkout. A team member confirms every order once it's placed.",
  },
  {
    q: "Is there a delivery minimum?",
    a: "Delivery is free on orders of $80 or more — just use code DC80 at checkout. Smaller orders may carry a small delivery fee depending on distance.",
  },
  {
    q: "Do I need to be 21 or older?",
    a: "Yes. CannaCheap DC serves adults 21+ only. A valid government-issued photo ID is required when your order is delivered or picked up — no exceptions.",
  },
  {
    q: "What is the price match promise?",
    a: "Find the same product cheaper at another local shop and we'll match the price. Just let us know when you order.",
  },
];

// Neighborhood SEO landing pages — add/remove entries here and re-run
// backend/seed_catalog.py to regenerate the sitemap.
export const NEIGHBORHOODS = [
  { slug: "the-wharf", name: "The Wharf", zip: "20024", region: "DC", blurb: "Waterfront delivery to The Wharf and Southwest — from Arena Stage to the Municipal Fish Market." },
  { slug: "navy-yard", name: "Navy Yard", zip: "20003", region: "DC", blurb: "Fast delivery across Navy Yard, Capitol Riverfront and the ballpark district." },
  { slug: "georgetown", name: "Georgetown", zip: "20007", region: "DC", blurb: "Serving Georgetown's historic streets, the university area and the waterfront." },
  { slug: "capitol-hill", name: "Capitol Hill", zip: "20003", region: "DC", blurb: "Reliable delivery across Capitol Hill, Eastern Market and Barracks Row." },
  { slug: "adams-morgan", name: "Adams Morgan", zip: "20009", region: "DC", blurb: "From 18th Street to Columbia Road — Adams Morgan delivery, day and evening." },
  { slug: "shaw", name: "Shaw", zip: "20001", region: "DC", blurb: "Covering Shaw, Blagden Alley and the U Street corridor's east side." },
  { slug: "dupont-circle", name: "Dupont Circle", zip: "20036", region: "DC", blurb: "Quick delivery around Dupont Circle, Embassy Row and Connecticut Avenue." },
  { slug: "columbia-heights", name: "Columbia Heights", zip: "20010", region: "DC", blurb: "Serving Columbia Heights, Meridian Hill and the 14th Street corridor." },
  { slug: "u-street", name: "U Street", zip: "20001", region: "DC", blurb: "Delivery along the U Street corridor, Cardozo and Logan's north side." },
  { slug: "logan-circle", name: "Logan Circle", zip: "20005", region: "DC", blurb: "Fast drop-offs around Logan Circle, 14th Street and downtown's north edge." },
  { slug: "noma", name: "NoMa", zip: "20002", region: "DC", blurb: "Covering NoMa, Union Market district and North Capitol Street." },
  { slug: "h-street-ne", name: "H Street NE", zip: "20002", region: "DC", blurb: "Delivery up and down the H Street corridor, Atlas District to Stanton Park." },
  { slug: "petworth", name: "Petworth", zip: "20011", region: "DC", blurb: "Serving Petworth, Georgia Avenue and the upper Northwest neighborhoods." },
  { slug: "brookland", name: "Brookland", zip: "20017", region: "DC", blurb: "Delivery to Brookland, Catholic University and the Monroe Street Arts Walk." },
  { slug: "foggy-bottom", name: "Foggy Bottom", zip: "20037", region: "DC", blurb: "Covering Foggy Bottom, GWU, the West End and the Kennedy Center area." },
  { slug: "bethesda-md", name: "Bethesda, MD", zip: "20814", region: "MD", blurb: "Delivery across downtown Bethesda and the surrounding Montgomery County neighborhoods." },
  { slug: "silver-spring-md", name: "Silver Spring, MD", zip: "20910", region: "MD", blurb: "Serving downtown Silver Spring and the DC line communities." },
  { slug: "takoma-park-md", name: "Takoma Park, MD", zip: "20912", region: "MD", blurb: "Fast delivery to Takoma Park and the surrounding neighborhoods." },
  { slug: "hyattsville-md", name: "Hyattsville, MD", zip: "20781", region: "MD", blurb: "Covering Hyattsville, the Arts District and Route 1 corridor." },
  { slug: "college-park-md", name: "College Park, MD", zip: "20740", region: "MD", blurb: "Delivery to College Park and the University of Maryland area." },
  { slug: "arlington-va", name: "Arlington, VA", zip: "22201", region: "VA", blurb: "Serving Arlington — Clarendon, Ballston, Rosslyn and Crystal City." },
  { slug: "alexandria-va", name: "Alexandria, VA", zip: "22314", region: "VA", blurb: "Delivery to Old Town Alexandria, Del Ray and the surrounding neighborhoods." },
];

export const PAYMENTS_NOTE =
  "Pay securely at checkout. We accept Cash, Cash App, Zelle and Apple Pay.";

// Google Business Profile — authentic aggregate data for the reviews features.
export const GOOGLE = {
  placeName: "Cannacheap Dispensary & Cannabis Delivery DC",
  rating: 4.8,
  count: 136,
  url: "https://www.google.com/maps/place/Cannacheap+Dispensary+%26+Cannabis+Delivery+DC/data=!4m2!3m1!1s0x0:0x98e88a419626ece",
  address: "77 District Square SW Fl 4, Washington, DC 20024",
};

// Verified review excerpts. Add more entries here as they're sourced from the
// Google listing — the homepage carousel and ribbon pick them up automatically.
export const GOOGLE_REVIEWS = [
  {
    name: "BGBM29",
    rating: 5,
    date: "Verified customer",
    text: "Great quality. Always reliable strains, super fast delivery — keep up the good work.",
  },
];

// Default hero deal — used until/unless overridden via the /admin editor
// (stored in MongoDB settings, served by GET /api/deal).
export const DEFAULT_DEAL = {
  badge: "This Week's Deal",
  title: "10g Shatter/Sauce",
  titleAccent: "+ Edible",
  description: "Bundle special — ten grams of shatter or sauce plus any edible on the menu.",
  price: "$200",
  priceNote: "all in",
  cta: "Claim This Deal",
  link: "/shop?on_sale=true",
  footnote: "While supplies last · 21+ only",
  enabled: true,
};

export const jsonLd = {
  organization: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "CannaCheap DC",
    url: "https://www.cannacheapdc.com",
    logo: "https://www.cannacheapdc.com/assets/logo.webp",
    telephone: "+1-202-422-9366",
    email: "info@cannacheap.store",
  },
  localBusiness: {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "CannaCheap DC",
    image: "https://www.cannacheapdc.com/assets/logo.webp",
    telephone: "+1-202-422-9366",
    email: "info@cannacheap.store",
    address: { "@type": "PostalAddress", streetAddress: "77 District Square SW Fl 4", addressLocality: "Washington", addressRegion: "DC", postalCode: "20024", addressCountry: "US" },
    openingHours: "Mo-Su 10:00-22:00",
    priceRange: "$$",
    aggregateRating: { "@type": "AggregateRating", ratingValue: "4.8", reviewCount: "136" },
    areaServed: ["Washington DC", "Bethesda MD", "Silver Spring MD", "Takoma Park MD", "Hyattsville MD", "College Park MD", "Arlington VA", "Alexandria VA"],
  },
};
